import React from "react";
import { useAppSelector } from "@/store/store";
import EstateSelectToolbar from "../../components/EstateSelectToolbar";
import AppBar from "./../../components/DefaultAppBar";
import ProfileHeader from "./ProfileHeader";

const route = "/profile/account";

function AccountContainer() {
  const currentEstate = useAppSelector(({ estates }) => estates.currentEstate);

  return (
    <div>
      <AppBar position="static">
        <EstateSelectToolbar noTicketFilter />
      </AppBar>

      <ProfileHeader estate={currentEstate} />
    </div>
  );
}

AccountContainer.route = route;

export default AccountContainer;
